import { InjectionKey, reactive } from '@vue/composition-api'
import flatpickr from 'flatpickr'

export type FormType = {
    base_path: string
    form_key: string
    before_unload_message: string
    can_yesterday_reserve: number
    form_legend: string
    banner: string
    banner_sp: string
    banner_label: string
    address_remark: string
    has_construction: number
    howto: {
        ordered: string
        label: string
        body: string
        has_address: string
    }[]
    ipad: string
    shop_field_label: string
    shops: {
        ordered: string
        label: string
        is_input: string
        contact_id?: string
        name?: string
        email?: string
        image?: string
        image_sp?: string
        address?: string
        phone?: string
        map_url?: string
        detail_url?: string
    }[]
    shop_groups: {
        [key: number]: {
            name: string
            shops: {
                ordered: string
                label: string
                is_input: string
                contact_id?: string
                name?: string
                email?: string
                image?: string
                image_sp?: string
                address?: string
                phone?: string
                map_url?: string
                detail_url?: string
            }[]
        }
    }
    phones: {
        ordered: string
        name: string
        number: string
    }[]
    date_start: string
    date_end: string
    holiday_week: string[]
    holidays: {
        ordered: string
        day: string
    }[]
    workdays: {
        ordered: string
        day: string
    }[]
    times: {
        ordered: string
        label: string
    }[]
    phone_modal_description: string
    questions: {
        ordered: string
        label: string
        is_checkbox: boolean
        answer?: {
            ordered: string
            label: string
            has_other_field: boolean
        }[]
    }[]
    importants: {
        ordered: string
        label: string
    }[]
    request_type: number
    request_alert: string
    requests: {
        ordered: string
        label: string
    }[]
    request_models: {
        ordered: string
        label: string
    }[]
    request_customs: {
        ordered: string
        label: string
    }[]
    privacy: string
    schedule_notes: {
        ordered: string
        label: string
    }[]
    start_day: number
    error_message: {
        error_name?: string
        error_tel?: string
        error_email?: string
        error_email_invalid?: string
        error_zip?: string
        error_address?: string
        error_howto?: string
        error_ipad?: string
        error_shop?: string
        error_date?: string
        error_time?: string
        error_question?: string
        error_privacy?: string
        error_first_time?: string
    }
}

export type FormRequestType = {
    base_path: string
    form_key: string
    before_unload_message: string
    can_yesterday_reserve: number
    form_legend: string
    banner: string
    banner_sp: string
    banner_label: string
    address_remark: string
    has_construction: number
    howto: {
        ordered: string
        label: string
        body: string
        has_address: string
    }[]
    ipad: string
    shop_field_label: string
    shops: {
        [key: number]: {
            name: string
            shops: {
                ordered: string
                label: string
                is_input: string
                contact_id?: string
                name?: string
                email?: string
                image?: string
                image_sp?: string
                address?: string
                phone?: string
                map_url?: string
                detail_url?: string
            }[]
        }
    }
    phones: {
        ordered: string
        name: string
        number: string
    }[]
    date_start: string
    date_end: string
    holiday_week: string[]
    holidays: {
        ordered: string
        day: string
    }[]
    workdays: {
        ordered: string
        day: string
    }[]
    times: {
        ordered: string
        label: string
    }[]
    phone_modal_description: string
    questions: {
        ordered: string
        label: string
        is_checkbox: boolean
        answer?: {
            ordered: string
            label: string
            has_other_field: boolean
        }[]
    }[]
    importants: {
        ordered: string
        label: string
    }[]
    request_type: number
    request_alert: string
    requests: {
        ordered: string
        label: string
    }[]
    request_models: {
        ordered: string
        label: string
    }[]
    request_customs: {
        ordered: string
        label: string
    }[]
    privacy: string
    schedule_notes: {
        ordered: string
        label: string
    }[]
    start_day: number
    error_message: {
        error_name?: string
        error_tel?: string
        error_email?: string
        error_email_invalid?: string
        error_zip?: string
        error_address?: string
        error_howto?: string
        error_ipad?: string
        error_shop?: string
        error_date?: string
        error_time?: string
        error_question?: string
        error_privacy?: string
        error_first_time?: string
    }
}

export default function store() {
    const state = reactive<FormType>({
        base_path: '',
        form_key: '',
        before_unload_message: '',
        can_yesterday_reserve: 0,
        form_legend: '',
        banner: '',
        banner_sp: '',
        banner_label: '',
        address_remark: '',
        has_construction: 0,
        howto: [],
        ipad: '0',
        shop_field_label: '',
        shops: [],
        shop_groups: {},
        phones: [],
        date_start: '',
        date_end: '',
        holiday_week: [],
        holidays: [],
        workdays: [],
        times: [],
        phone_modal_description: '',
        questions: [],
        importants: [],
        request_type: 0,
        request_alert: '',
        requests: [
            {
                ordered: '1',
                label: 'モデルハウスを見学したい',
            },
            {
                ordered: '2',
                label: '建物の金額が知りたい',
            },
            {
                ordered: '3',
                label: '返済など資金の計画を教えてほしい',
            },
            {
                ordered: '4',
                label: '土地を紹介してほしい',
            },
            {
                ordered: '5',
                label: '間取りについてアドバイスが欲しい',
            },
            {
                ordered: '6',
                label: '商品の特徴を知りたい',
            },
            {
                ordered: '7',
                label: '会社の強みを知りたい',
            },
            {
                ordered: '8',
                label: '建物性能について知りたい',
            },
            {
                ordered: '9',
                label: '保証・アフターフォローについて知りたい',
            },
            {
                ordered: '10',
                label: 'その他',
            },
        ],
        request_models: [
            {
                ordered: '1',
                label: '特徴を知りたい',
            },
            {
                ordered: '2',
                label: 'モデルハウスの購入額を詳しく知りたい',
            },
            {
                ordered: '3',
                label: 'モデルハウスの設備・仕様を詳しく知りたい',
            },
            {
                ordered: '4',
                label: '返済など資金の計画を教えてほしい',
            },
            {
                ordered: '5',
                label: '会社の強みを知りたい',
            },
            {
                ordered: '6',
                label: '保証・アフターについて知りたい',
            },
            {
                ordered: '7',
                label: 'その他',
            },
        ],
        request_customs: [],
        privacy: '',
        schedule_notes: [],
        start_day: 0,
        error_message: {},
    })

    return {
        get base_path() {
            return state.base_path
        },
        set base_path(base_path) {
            state.base_path = base_path
        },

        // form_key
        get form_key() {
            return state.form_key
        },

        // before_unload_message
        get before_unload_message() {
            return state.before_unload_message
        },

        // can_yesterday_reserve
        get can_yesterday_reserve() {
            return state.can_yesterday_reserve
        },

        // form_legend
        get form_legend() {
            return state.form_legend
        },

        // banner
        get banner() {
            return state.banner
        },

        // banner_sp
        get banner_sp() {
            return state.banner_sp
        },

        // banner_label
        get banner_label() {
            return state.banner_label
        },

        // address_remark
        get address_remark() {
            return state.address_remark
        },

        // has_construction
        get has_construction() {
            return state.has_construction
        },

        // howto
        get howto() {
            return state.howto
        },

        // ipad
        get ipad() {
            return state.ipad
        },

        // shop_field_label
        get shop_field_label() {
            return state.shop_field_label
        },

        // shops
        get shops() {
            return state.shops
        },

        // shops
        get shop_groups() {
            return state.shop_groups
        },

        // phones
        get phones() {
            return state.phones
        },

        // date_start
        get date_start() {
            return state.date_start
        },

        get calced_date_start() {
            const dateStart = flatpickr.parseDate(state.date_start, 'Y-m-d')
            const calcedDateStart = (new Date() as any).fp_incr(
                state.start_day || 0
            )

            if (dateStart && calcedDateStart) {
                return dateStart.getTime() >= calcedDateStart.getTime()
                    ? dateStart
                    : calcedDateStart
            }

            if (calcedDateStart) {
                return calcedDateStart
            }

            return state.date_start
        },

        // date_end
        get date_end() {
            return state.date_end
        },

        // holiday_week
        get holiday_week() {
            return state.holiday_week
        },

        // holidays
        get holidays() {
            return state.holidays
        },

        // workdays
        get workdays() {
            return state.workdays
        },

        // times
        get times() {
            return state.times
        },

        // phone_modal_description
        get phone_modal_description() {
            return state.phone_modal_description
        },

        // questions
        get questions() {
            return state.questions
        },

        // importants
        get importants() {
            return state.importants
        },

        // request_type
        get request_type() {
            return state.request_type
        },

        // request_alert
        get request_alert() {
            return state.request_alert
        },

        // requests
        get requests() {
            return state.requests
        },

        // request_models
        get request_models() {
            return state.request_models
        },

        // request_customs
        get request_customs() {
            return state.request_customs
        },

        // privacy
        get privacy() {
            return state.privacy
        },

        // schedule_notes
        get schedule_notes() {
            return state.schedule_notes
        },

        // start_day
        get start_day() {
            return state.start_day
        },

        // error_message
        get error_message() {
            return state.error_message
        },

        update(data: FormRequestType) {
            state.form_key = data.form_key
            state.before_unload_message = data.before_unload_message
            state.can_yesterday_reserve = data.can_yesterday_reserve - 0
            state.form_legend = data.form_legend
            state.banner = data.banner
            state.banner_sp = data.banner_sp
            state.banner_label = data.banner_label
            state.address_remark = data.address_remark
            state.has_construction = data.has_construction - 0
            state.howto = data.howto
            state.ipad = data.ipad
            state.shop_field_label = data.shop_field_label
            state.phones = data.phones
            state.date_start = data.date_start
            state.date_end = data.date_end
            state.holiday_week = data.holiday_week
            state.holidays = data.holidays
            state.workdays = data.workdays
            state.times = data.times
            state.phone_modal_description = data.phone_modal_description
            state.questions = data.questions
            state.importants = data.importants
            state.request_customs = data.requests
            state.request_type = data.request_type - 0
            state.request_alert = data.request_alert
            state.privacy = data.privacy
            state.schedule_notes = data.schedule_notes
            state.start_day = parseInt(data.start_day + '')
            state.error_message = { ...data.error_message }

            // Shops convert
            const shops: {
                ordered: string
                label: string
                is_input: string
                contact_id?: string
                name?: string
                email?: string
            }[] = []
            Object.keys(data.shops).map((i) => {
                const group = data.shops[parseInt(i, 10)]
                group.shops.map((shop) => {
                    shops.push(shop)
                })
            })
            state.shops = shops
            state.shop_groups = data.shops
        },
    }
}

export type StoreType = ReturnType<typeof store>
export const StoreKey: InjectionKey<StoreType> = Symbol('FormType')
